export interface ILocalStorage extends Storage {}

export class WindowLocalStorage implements ILocalStorage {
    private readonly localStorage: Storage;

    constructor(window: Window) {
        this.localStorage = window.localStorage;
    }

    get length(): number {
        return this.localStorage.length;
    }

    clear(): void {
        this.localStorage.clear();
    }

    getItem(key: string): string | null {
        return this.localStorage.getItem(key);
    }

    key(index: number): string | null {
        return this.localStorage.key(index);
    }

    removeItem(key: string): void {
        this.localStorage.removeItem(key);
    }

    setItem(key: string, value: string): void {
        this.localStorage.setItem(key, value);
    }
}

export class InMemoryLocalStorage implements ILocalStorage {
    private localStorage: any;

    constructor() {
        this.localStorage = {};
    }

    get length(): number {
        return Object.keys(this.localStorage).length;
    }

    clear(): void {
        this.localStorage = {};
    }

    getItem(key: string): string | null {
        return this.localStorage[key] || null;
    }

    key(index: number): string | null {
        return Object.keys(this.localStorage)[index] || null;
    }

    removeItem(key: string): void {
        delete this.localStorage[key];
    }

    setItem(key: string, value: string): void {
        this.localStorage[key] = value;
    }
}
